import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { LiveChat } from './components/LiveChat';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { ScrollToTopButton } from './components/ScrollToTopButton';
import { PageTransition } from './components/PageTransition';
import { Home } from './pages/Home';
import { Contact } from './pages/Contact';
import { Product } from './pages/Product';
import { HelpMeChoose } from './pages/HelpMeChoose';
import { AboutPage } from './pages/AboutPage';
import { DeliveryZones } from './pages/DeliveryZones';
import { Subcontractors } from './pages/Subcontractors';
import { DiyHelp } from './pages/DiyHelp';
import { ContractorOrdering } from './pages/ContractorOrdering';
import { DeliveryPrep } from './pages/DeliveryPrep';
import { CompareMaterials } from './pages/CompareMaterials';
import { NotFound } from './pages/NotFound';
import { CartProvider } from './components/CartContext';
import { CartDrawer } from './components/CartDrawer';
import { AnnouncementBar } from './components/AnnouncementBar';
function ScrollToHash() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace('#', ''));
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <Routes location={location} key={location.pathname} data-id="element-1">
        <Route path="/" element={<PageTransition data-id="element-3">
              <Home data-id="element-4" />
            </PageTransition>} data-id="element-2" />
        <Route path="/contact" element={<PageTransition data-id="element-6">
              <Contact data-id="element-7" />
            </PageTransition>} data-id="element-5" />
        <Route path="/shop/:slug" element={<PageTransition data-id="element-9">
              <Product data-id="element-10" />
            </PageTransition>} data-id="element-8" />
        <Route path="/help" element={<PageTransition data-id="element-12">
              <HelpMeChoose data-id="element-13" />
            </PageTransition>} data-id="element-11" />
        <Route path="/about" element={<PageTransition data-id="element-15">
              <AboutPage data-id="element-16" />
            </PageTransition>} data-id="element-14" />
        <Route path="/delivery-zones" element={<PageTransition data-id="element-18">
              <DeliveryZones data-id="element-19" />
            </PageTransition>} data-id="element-17" />
        <Route path="/subcontractors" element={<PageTransition data-id="element-21">
              <Subcontractors data-id="element-22" />
            </PageTransition>} data-id="element-20" />
        <Route path="/contractor-ordering" element={<PageTransition data-id="element-24">
              <Subcontractors data-id="element-25" />
            </PageTransition>} data-id="element-23" />
        <Route path="/diy-help" element={<PageTransition data-id="element-27">
              <DiyHelp data-id="element-28" />
            </PageTransition>} data-id="element-26" />
        <Route path="/delivery-prep" element={<PageTransition data-id="element-30">
              <DeliveryPrep data-id="element-31" />
            </PageTransition>} data-id="element-29" />
        <Route path="/compare" element={<PageTransition data-id="element-33">
              <CompareMaterials data-id="element-34" />
            </PageTransition>} data-id="element-32" />
        <Route path="*" element={<PageTransition data-id="element-36">
              <NotFound data-id="element-37" />
            </PageTransition>} data-id="element-35" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved) {
      return saved === 'dark';
    }
    return true;
  });
  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);
  const toggleDark = () => setIsDark(!isDark);
  return <Router data-id="element-38">
      <CartProvider data-id="element-39">
        <div className={`min-h-screen flex flex-col font-sans ${isDark ? 'dark' : ''}`} data-id="element-40">
          <div className="flex-grow bg-[#fdfbf7] dark:bg-[#222222] transition-colors duration-300 pb-16 md:pb-0" data-id="element-41">
            <ScrollToHash data-id="element-42" />
            <AnnouncementBar data-id="element-43" />
            <Navbar isDark={isDark} toggleDark={toggleDark} data-id="element-44" />
            <AnimatedRoutes data-id="element-45" />
            <Footer data-id="element-46" />
            <LiveChat data-id="element-47" />
            <StickyMobileCTA data-id="element-48" />
            <ScrollToTopButton data-id="element-49" />
            <CartDrawer data-id="element-50" />
          </div>
        </div>
      </CartProvider>
    </Router>;
}